import { render, staticRenderFns } from "./DiagResultTutorial.vue?vue&type=template&id=01181105&"
import script from "./DiagResultTutorial.vue?vue&type=script&lang=js&"
export * from "./DiagResultTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports